/**
 * Jobs-board partner creatives are 1000×217 (desktop) and 500×417 (mobile).
 * Outliers (Remitly mobile, Twine Rewards) should be re-exported to these sizes.
 */
export const JOBS_BOARD_DESKTOP_CREATIVE = { width: 1000, height: 217 };
export const JOBS_BOARD_MOBILE_CREATIVE = { width: 500, height: 417 };
